/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Te_Effect_No_EffectInputs */

const en_ui_te_effect_no_effect = /** @type {(inputs: Ui_Te_Effect_No_EffectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No Effect`)
};

const de_ui_te_effect_no_effect = /** @type {(inputs: Ui_Te_Effect_No_EffectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kein Effekt`)
};

/**
* | output |
* | --- |
* | "No Effect" |
*
* @param {Ui_Te_Effect_No_EffectInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_te_effect_no_effect = /** @type {((inputs?: Ui_Te_Effect_No_EffectInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Te_Effect_No_EffectInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_te_effect_no_effect(inputs)
	return de_ui_te_effect_no_effect(inputs)
});